export const VEHICLES = {
  MOBILE_HOMES: 'fcr/vehicles/MOBILE_HOMES',
  MOTOR_VEHICLE: 'fcr/vehicles/MOTOR_VEHICLE',
  VESSELS: 'fcr/vehicles/VESSELS',
  HEAVY_TRUCKS: 'fcr/vehicles/HEAVY_TRUCKS',
  LEASE_HIRE_TRAILER: 'vehicles/const/LEASE_HIRE_TRAILER',
  BUSES_TRAILER: 'fcr/vehicles/BUSES_TRAILER',
};

export const TITLES = {
  FLORIDA_TITLE: 'fcr/titles/FLORIDA_TITLE',
  MCO_TITLE: 'fcr/titles/MCO_TITLE',
  OOS_TITLE: 'fcr/titles/OOS_TITLE',
};

export const PIPE = {
  DESCRIPTION: 'fcr/pipe/DESCRIPTION',
  ONE_MONTH: 'fcr/pipe/ONE_MONTH',
  TWO_MONTH: 'fcr/pipe/TWO_MONTH',
  THREE_MONTH: 'fcr/pipe/THREE_MONTH',
  FOUR_MONTH: 'fcr/pipe/FOUR_MONTH',
  FIVE_MONTH: 'fcr/pipe/FIVE_MONTH',
  SIX_MONTH: 'fcr/pipe/SIX_MONTH',
  SEVEN_MONTH: 'fcr/pipe/SEVEN_MONTH',
  EIGHT_MONTH: 'fcr/pipe/EIGHT_MONTH',
  NINE_MONTH: 'fcr/pipe/NINE_MONTH',
  TEN_MONTH: 'fcr/pipe/TEN_MONTH',
  ELEVEN_MONTH: 'fcr/pipe/ELEVEN_MONTH',
  TWELVE_MONTH: 'fcr/pipe/TWELVE_MONTH',
  THIRTEEN_MONTH: 'fcr/pipe/THIRTEEN_MONTH',
  FOURTEEN_MONTH: 'fcr/pipe/FOURTEEN_MONTH',
  FIFTEEN_MONTH: 'fcr/pipe/FIFTEEN_MONTH',
  TITLED: 'fcr/pipe/TITLED',
  BIENNIEL_2ND_YEAR: 'fcr/pipe/BIENNIEL_2ND_YEAR',
  PENALTY: 'fcr/pipe/PENALTY',
  INITIAL_FEE_REQUIRED: 'fcr/pipe/INITIAL_FEE_REQUIRED',
  SPECIALITY_PERSONALIZED: 'fcr/pipe/SPECIALITY_PERSONALIZED',
  SERVICE_FEE_VARIABLE: 'fcr/pipe/SERVICE_FEE_VARIABLE',
  GROUP_TOTAL: 'fcr/pipe/GROUP_TOTAL',
  CLASS_CODE: 'fcr/pipe/CLASS_CODE',
};

export const ACTIONS = {
  RESET: 'fcr/actions/RESET_ACTION',
  RESET_REGISTRATION: 'fcr/actions/RESET_REGISTRATION',
  SET_MOBILE_HOME_LENGTH: 'fcr/actions/SET_MOBILE_HOME_LENGTH',
  RESET_MOBILE_HOME: 'fcr/actions/RESET_MOBILE_HOME',
  RESET_ALL_EXCEPT_MONTH: 'fcr/actions/RESET_ALL_EXCEPT_MONTH',
  SET_EXPIRATION_MONTH: 'fcr/registration/SET_EXPIRATION_MONTH',
  TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE: 'fcr/registration/TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE',
  TOGGLE_SHOULD_CHARGE_BRANCH_FEE: 'fcr/registration/TOGGLE_SHOULD_CHARGE_BRANCH_FEE',
};

export const TAX = {
  FLORIDA_SALES_TAX: 0.06,
};



// WEBPACK FOOTER //
// ./src/modules/constants.js